// 爱上班、爱客-CRM、爱客-钉钉
import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3>微信网站(微客来)</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="工号">{data.c_num}</Description>
          <Description term="赠送年限">{data.c_free}</Description>
          <Description term="年数">{data.c_years}</Description>
        </Row>
        <Row>
          <Description term="价格">{data.c_money}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProCRM.js